import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class SaveGameIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
                <g fill="transparent">
                    <path d="M6.2 0.999999C5.86266 0.999999 5.53819 1.14033 5.29956 1.39066C5.06088 1.64066 4.92725 1.97967 4.92725 2.33332V20.0887C4.92725 20.592 5.31544 21 5.79588 21H5.79909C6.05682 21 6.30179 20.8927 6.48315 20.702C7.32632 19.8193 9.81451 17.2127 10.8423 16.138C11.1286 15.8363 11.5199 15.6667 11.9273 15.6667C12.3346 15.6667 12.7259 15.8363 13.0122 16.138C14.0431 17.216 16.5441 19.8354 17.3777 20.71C17.5559 20.8957 17.7945 21 18.0459 21C18.5327 21 18.9272 20.587 18.9272 20.0773V2.33332C18.9272 1.97967 18.7936 1.64066 18.555 1.39066C18.3163 1.14033 17.9918 0.999999 17.6545 0.999999H6.2Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
        </SvgIcon>;
    }
}
